import React from "react";
import { Button, Flex } from "antd";
import { PlaceholderColorPicker } from "./PlaceholderColorPicker";
import { ColorWheelIcon } from "components/icons/";
import { useTranslate } from "@refinedev/core";
import { PaletteResponse } from "pages/media/types";
import { useTemplatesStatusStore } from "../../store/useTemplatesStatusStore";
import { MediaItem, Shape } from "../../types";
import { isGradient } from "../../helpers/itemsHelper";

type TemplateItemWithStroke = MediaItem | Shape;

interface StrokeColorControlProps {
  item: TemplateItemWithStroke;
  pickedItemAction: (item: TemplateItemWithStroke) => void;
  previewWidth: number;
  palette?: PaletteResponse;
}

export const StrokeColorControl: React.FC<StrokeColorControlProps> = ({
  item,
  pickedItemAction,
  previewWidth,
  palette,
}) => {
  const t = useTranslate();
  const { addTemplateUpdate } = useTemplatesStatusStore((state) => ({
    addTemplateUpdate: state.addTemplateUpdate,
  }));
  return (
    <PlaceholderColorPicker
      title={t("components.templates.settings.strokeColor")}
      value={item.stroke?.color}
      allowClear={true}
      onChangeComplete={(resolvedColor) => {
        if (isGradient(resolvedColor)) return;
        pickedItemAction({
          ...item,
          stroke: {
            ...item.stroke,
            width: item.stroke?.width ?? 1 / previewWidth,
            color: resolvedColor,
          },
        });
        addTemplateUpdate();
      }}
      onClear={() => {
        pickedItemAction({
          ...item,
          stroke: {
            ...item.stroke,
            width: null,
            color: null,
          },
        });
        addTemplateUpdate();
      }}
      getPopupContainer={(triggerNode) =>
        triggerNode.parentElement ?? triggerNode
      }
      palette={palette}
    >
      <Button
        type="text"
        size="middle"
        icon={
          <Flex align="center" justify="center">
            <ColorWheelIcon />
          </Flex>
        }
      />
    </PlaceholderColorPicker>
  );
};
